import React, { createContext, useEffect, useState } from 'react'
import httpCommon from 'src/http-common';

export const DateContext = createContext("");


function DateContextProvider({children}) {

  const today = new Date();
    const site_Cd = localStorage.getItem('ww_Hsp');
    const [from, setFrom] = useState();
    const [to, setTo] = useState(today);
    const [toogleApi,setToogleApi]=useState(false)
    
  


    // const oneYearAgo = new Date(today);
    // oneYearAgo.setDate(today.getDate() - 365);

    const fetchFromDay =async()=>{
      try {
        const response = await httpCommon.get(
          `/get_from_to.php?site_cd=${site_Cd}`
        );
    
        if (response.data.status === 'SUCCESS') {
         
          let date = response.data.data
         
          setFrom(date);
          setToogleApi(true)
          localStorage.setItem("firstFrom",response.data.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    
      // handle Date useEffect
      useEffect(()=>{
        fetchFromDay();
    
      },[])


  return (
    <div>
  <DateContext.Provider value={{ from, setFrom,to,setTo,toogleApi,setToogleApi }}>
        {children}
</DateContext.Provider>
    </div>
  )
}

export default DateContextProvider
